const SUPPORT_VK_URL = 'https://vk.com/im/convo/-236691597?entrypoint=community_page&tab=all';
const SUPPORT_EMAIL = 'fabrica.uno@mail.ru';

const SUPPORT_PICKER_ID = 'support-picker-overlay';

/**
 * Показывает модальное окно выбора способа связи: VK или почта.
 * После выбора открывает ссылку и закрывает окно.
 */
export function showSupportChoice(): void {
  if (typeof document === 'undefined') return;
  if (document.getElementById(SUPPORT_PICKER_ID)) return;

  const overlay = document.createElement('div');
  overlay.id = SUPPORT_PICKER_ID;
  overlay.innerHTML = `
    <style>
      #${SUPPORT_PICKER_ID} {
        position: fixed;
        inset: 0;
        z-index: 1000000;
        background: rgb(0 0 0 / 80%);
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
      }
      #${SUPPORT_PICKER_ID} .support-picker-box {
        background: #1a1a1a;
        border-radius: 12px;
        padding: 20px 24px;
        box-shadow: 0 10px 40px rgba(0,0,0,0.5);
        min-width: 260px;
      }
      #${SUPPORT_PICKER_ID} .support-picker-title {
        color: #fff;
        font-size: 14px;
        font-weight: 600;
        margin-bottom: 16px;
        text-align: center;
      }
      #${SUPPORT_PICKER_ID} .support-picker-buttons {
        display: flex;
        gap: 10px;
        justify-content: center;
        flex-wrap: wrap;
      }
      #${SUPPORT_PICKER_ID} .support-picker-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 10px 18px;
        border-radius: 8px;
        font-size: 13px;
        font-weight: 600;
        cursor: pointer;
        text-decoration: none;
        color: #000;
        background: #ffffff;
        border: none;
        transition: background 0.15s ease;
      }
      #${SUPPORT_PICKER_ID} .support-picker-btn:hover {
        background: #f0f0f0;
      }
      #${SUPPORT_PICKER_ID} .support-picker-copied {
        color: #fff;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        padding: 8px 0 0;
        display: none;
      }
    </style>
    <div class="support-picker-box">
      <div class="support-picker-title">Связаться с нами</div>
      <div class="support-picker-buttons">
        <a href="${SUPPORT_VK_URL}" target="_blank" rel="noopener" class="support-picker-btn" data-action="vk">VK</a>
        <a href="mailto:${SUPPORT_EMAIL}" class="support-picker-btn" data-action="mail">Почта</a>
      </div>
      <div class="support-picker-copied">Почта скопирована</div>
    </div>
  `;

  function close(): void {
    document.removeEventListener('keydown', onKeydown);
    overlay.remove();
  }

  function onKeydown(e: KeyboardEvent): void {
    if (e.key === 'Escape') close();
  }

  overlay.addEventListener('click', (e) => {
    const mailLink = (e.target as HTMLElement).closest('a[data-action="mail"]');
    if (mailLink) {
      e.preventDefault();
      navigator.clipboard.writeText(SUPPORT_EMAIL).then(
        () => {
          const box = overlay.querySelector('.support-picker-box');
          const buttons = box?.querySelector('.support-picker-buttons') as HTMLElement | null;
          const copiedEl = box?.querySelector('.support-picker-copied') as HTMLElement | null;
          if (buttons) buttons.style.display = 'none';
          if (copiedEl) copiedEl.style.display = 'block';
          setTimeout(close, 2000);
        },
        () => { close(); window.location.href = `mailto:${SUPPORT_EMAIL}`; }
      );
      return;
    }
    if ((e.target as HTMLElement).closest('.support-picker-box') && (e.target as HTMLElement).closest('a')) {
      close();
    }
    if (e.target === overlay) close();
  });

  document.addEventListener('keydown', onKeydown);
  document.body.appendChild(overlay);
}

export { SUPPORT_VK_URL, SUPPORT_EMAIL };
